export default __webpack_public_path__ + "static/IDC-ddb239eb8cd26052daa89dd47c44e7f0.png";